import React from "react";
import { Box, Paper, Grid, TextField, Typography } from "@mui/material";
import QuestionsTabs from "./QuestionsTabs";

type Props = {
  index: number;
  data: any;
  onChange: (newData: any) => void;
};

function SectionForm({ index, data, onChange }: Props) {
  const handleChange = (key: string, value: any) => {
    onChange({ ...data, [key]: value });
  };

  return (
    <Paper
      sx={{
        p: 3,
        mt: 3,
        borderRadius: 2,
        border: "1px solid #e0e0e0",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      }}
      variant="outlined"
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: 2 }}
      >
        <Typography variant="h6" fontWeight="bold" color="primary">
          Section {index + 1}
        </Typography>
      </Box>

      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6}>
          <TextField
            value={data.title || ""}
            onChange={(e) => handleChange("title", e.target.value)}
            label="Section Title"
            size="small"
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            type="number"
            value={data.order || ""}
            onChange={(e) => handleChange("order", Number(e.target.value))}
            label="Section Order"
            size="small"
            fullWidth
            disabled
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            type="number"
            value={data.choiceCount || ""}
            onChange={(e) =>
              handleChange("choiceCount", Number(e.target.value))
            }
            label="Choice Count"
            size="small"
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            type="number"
            value={data.marks || ""}
            onChange={(e) => handleChange("marks", Number(e.target.value))}
            label="Marks"
            size="small"
            fullWidth
          />
        </Grid>
      </Grid>

      <Box
        sx={{
          mt: 3,
          p: 2,
          backgroundColor: "#f8f9fa",
          borderRadius: 2,
          border: "1px solid #e0e0e0",
        }}
      >
        <QuestionsTabs
          questions={data.questions || []}
          onChange={(newQuestions) => handleChange("questions", newQuestions)}
        />
      </Box>
    </Paper>
  );
}

export default SectionForm;
